import { render } from "./modalv3.vue?vue&type=template&id=df3455c2&scoped=true"
import script from "./modalv3.vue?vue&type=script&lang=js"
export * from "./modalv3.vue?vue&type=script&lang=js"

import "./modalv3.vue?vue&type=style&index=0&id=df3455c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df3455c2"]])

export default __exports__